//1.导入vue和router包
import Vue from 'vue'
import VueRouter from 'vue-router'
// import layout from '@/views/layout/index.vue'
import login from '@/views/login/login.vue'
import dept from '@/views/layout/content/dept.vue'


import preview from '@/views/layout/content/previews/preview.vue'
import mediaPreview from '@/views/layout/content/previews/mediaPreview.vue'
import previewSet from '@/views/layout/content/previews/previewSet.vue'
import publishPreview from '@/views/layout/content/previews/publishPreview.vue'
import publishVideoPreview from '@/views/layout/content/previews/publishVideoPreview.vue'
import publishAudioPreview from '@/views/layout/content/previews/publishAudioPreview.vue'
import setPublishPreview from '@/views/layout/content/previews/setPublishPreview.vue'
import qaPreview from '@/views/layout/content/previews/qaPreview.vue'

import blank from '@/views/layout/content/previews/blank.vue'

import user from '@/views/layout/content/authority/user.vue'//用户管理
import role from '@/views/layout/content/authority/role.vue'//角色管理
import authority from '@/views/layout/content/authority/authority.vue'//权限管理
import sortManage from '@/views/layout/content/dataBase/sortManage.vue'//资源库分类管理
import dataBseManage from '@/views/layout/content/dataBase/dataBseManage.vue'//资源库管理
import sourceManage from '@/views/layout/content/dataBase/sourceManage.vue'//来源管理
import dbSortManage from '@/views/layout/content/dataBase/dbSortManage.vue'//数据类别管理
import sourceToStorage from '@/views/layout/content/toStorage/sourceToStorage.vue'//资源入库
import mediaToStorage from '@/views/layout/content/toStorage/mediaToStorage.vue'//多媒体资源入库
import DToStorage from '@/views/layout/content/toStorage/3DToStorage.vue'//3D资源入库
import bkManage from '@/views/layout/content/dbWork/bkManage.vue'//百科全书资源管理

import dicToolManage from '@/views/layout/content/dbWork/dicToolManage.vue'//辞典工具资源管理

import speciaDBManage from '@/views/layout/content/dbWork/speciaDBManage.vue'//专项数据资源管理

import mediaManage from '@/views/layout/content/dbWork/mediaManage.vue'//多媒体资源管理

import mediaSet from '@/views/layout/content/dbWork/mediaSet.vue'//多媒体集资源管理

import bookManage from '@/views/layout/content/dbWork/bookManage.vue'//图书资源管理

import qaManage from '@/views/layout/content/dbWork/qaManage.vue'//问答对资源管理

import outdbManage from '@/views/layout/content/dbWork/outdbManage.vue'//出库任务管理

import repeatCheck from '@/views/layout/content/dbWork/repeatCheck.vue'//资源查重

import expWorkList from '@/views/layout/content/dbWork/expWorkList.vue'//导出任务列表

import contentEdit from '@/views/layout/content/dbWork/contentEdit.vue'//内容编辑

import taglibManage from '@/views/layout/content/labelManage/taglibManage.vue'//标签库管理

import indexlibManage from '@/views/layout/content/labelManage/indexlibManage.vue'//标引库管理

import editBoardManage from '@/views/layout/content/dbWork/editBoardManage.vue'//编委库管理

import bigEvent from '@/views/layout/content/dbWork/bigEvent.vue'//大事记管理

import adManage from '@/views/layout/content/dbWork/adManage.vue'//多媒体资源管理

import countPage from '@/views/layout/count/countPage.vue'//统计页面
import fullSearch from '@/views/layout/fullSearch/fullSearch.vue'//统计页面

import knowledgeContent from '@/views/layout/count/knowledgeContent.vue'//统计页面

// 用户前端页面
import Home from '@/views/web/Home.vue'//用户首页
import categoryPage from '@/views/web/categoryPage.vue'


//2.调用Vue.use()函数，把 VueRouter 安装为 Vue 的插件
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'fullSearch',
        component: fullSearch
    },
    {
        path: '/countPage',
        name: 'countPage',
        component: countPage
    },
    {
        path: '/fullSearch',
        name: 'fullSearch',
        component: fullSearch
    },
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/deptZyk',
        name: 'deptZyk',
        component: dept
    }, {
        path: '/user',
        name: 'user',
        component: user
    }, {
        path: '/previewSet',
        name: 'previewSet',
        component: previewSet
    }, 
    {
        path: '/mediaPreview',
        name: 'mediaPreview',
        component: mediaPreview
    }, 
    {
        path: '/qaPreview',
        name: 'qaPreview',
        component: qaPreview
    },
    {
        path: '/preview',
        name: 'preview',
        component: preview
    },
    {
        path: '/detail',
        name: 'detail',
        component: publishPreview
    },
    {
        path: '/videoDetail',
        name: 'videoDetail',
        component: publishVideoPreview
    },
    {
        path: '/audioDetail',
        name: 'audioDetail',
        component: publishAudioPreview
    },
    {
        path: '/setDetail',
        name: 'setDetail',
        component: setPublishPreview
    },
    {
        path: '/blank',
        name: 'blank',
        component: blank
    }, {
        path: '/role',
        name: 'role',
        component: role
    }
    , {
        path: '/authority',
        name: 'authority',
        component: authority
    }, {
        path: '/sortManage',
        name: 'sortManage',
        component: sortManage
    }, {
        path: '/contentEdit',
        name: 'contentEdit',
        component: contentEdit,
    }, {
        path: '/dataBseManage',
        name: 'dataBseManage',
        component: dataBseManage
    }, {
        path: '/sourceManage',
        name: 'sourceManage',
        component: sourceManage
    }
    , {
        path: '/dbSortManage',
        name: 'dbSortManage',
        component: dbSortManage
    }, {
        path: '/sourceToStorage',
        name: 'sourceToStorage',
        component: sourceToStorage
    }
    , {
        path: '/mediaToStorage',
        name: 'mediaToStorage',
        component: mediaToStorage
    }, {
        path: '/3DToStorage',
        name: '3DToStorage',
        component: DToStorage
    }
    , {
        path: '/bkManage',
        name: 'bkManage',
        component: bkManage
    }
    , {
        path: '/dicToolManage',
        name: 'dicToolManage',
        component: dicToolManage
    }
    , {
        path: '/speciaDBManage',
        name: 'speciaDBManage',
        component: speciaDBManage
    }
    , {
        path: '/mediaManageZyk',
        name: 'mediaManageZyk',
        component: mediaManage
    }
    , {
        path: '/mediaSetZyk',
        name: 'mediaSetZyk',
        component: mediaSet
    }
    , {
        path: '/outdbManage',
        name: 'outdbManage',
        component: outdbManage
    }
    , {
        path: '/bookManage',
        name: 'bookManage',
        component: bookManage
    },
    {
        path: '/qaManage',
        name: 'qaManage',
        component: qaManage
    }, 
    {
        path: '/repeatCheck',
        name: 'repeatCheck',
        component: repeatCheck
    }
    , {
        path: '/taglibManage',
        name: 'taglibManage',
        component: taglibManage
    }
    , {
        path: '/indexlibManage',
        name: 'indexlibManage',
        component: indexlibManage
    }
    , {
        path: '/editBoardManage',
        name: 'editBoardManage',
        component: editBoardManage
    }
    , {
        path: '/bigEvent',
        name: 'bigEvent',
        component: bigEvent
    }
    , {
        path: '/adManage',
        name: 'adManage',
        component: adManage
    }
    , {
        path: '/knowledgeContent',
        name: 'knowledgeContent',
        component: knowledgeContent
    }
    , {
        path: '/expWorkList',
        name: 'expWorkList',
        component: expWorkList
    }
    , {
        path: '/Home',
        name: 'Home',
        component: Home
    }
    , {
        path: '/categoryPage',
        name: 'categoryPage',
        component: categoryPage
    }
]

//3.创建路由的示例对象
const router = new VueRouter({
    // mode: 'hash',
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

//4.向外共享路由示例对象
export default router